import { useState, useCallback } from "react";

import { Button } from "reactstrap";
import { PlusIcon } from "@heroicons/react/24/outline";

import { CreateMilestoneModal } from "./CreateMilestoneModal";

interface CreateMilestoneModalButtonProps {
  assignment_id: string;
}

export const CreateMilestoneModalButton = ({
  assignment_id,
}: CreateMilestoneModalButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <div className="create-milestone">
      <Button
        color="dark"
        className="ms-3 d-flex align-items-center"
        onClick={handleOpenModal}
      >
        <PlusIcon height={20} width={20} className="me-2" />
        Create Milestone
      </Button>

      <CreateMilestoneModal
        assignment_id={assignment_id}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </div>
  );
};

export default CreateMilestoneModalButton;
